var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("群組保護設定")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("群組保護設定")]), _c('div', {
    staticClass: "row d-flex justify-content-between align-items-center my-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4 d-flex align-items-center flex-nowrap"
  }, [_c('h6', {
    staticClass: "mb-xl-0 font-weight-bold text-nowrap mr-2"
  }, [_vm._v("群組")]), _c('b-form-select', {
    attrs: {
      "options": _vm.groups.map(function (x) {
        return {
          text: "".concat(x.branch_code, " ").concat(x.name),
          value: x.id
        };
      })
    },
    on: {
      "change": _vm.fetchSetting
    },
    scopedSlots: _vm._u([_vm.groups.length != 1 ? {
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("-- 請選擇 --")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.guardGroup,
      callback: function callback($$v) {
        _vm.guardGroup = $$v;
      },
      expression: "guardGroup"
    }
  })], 1)]), _vm.guardGroup ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-form-checkbox', {
    staticClass: "ml-2 mb-2",
    model: {
      value: _vm.currentGroup.protect_invite,
      callback: function callback($$v) {
        _vm.$set(_vm.currentGroup, "protect_invite", $$v);
      },
      expression: "currentGroup.protect_invite"
    }
  }, [_vm._v(" 邀請成員保護 ")]), _c('b-form-checkbox', {
    staticClass: "ml-2 mb-2",
    model: {
      value: _vm.currentGroup.protect_avatar,
      callback: function callback($$v) {
        _vm.$set(_vm.currentGroup, "protect_avatar", $$v);
      },
      expression: "currentGroup.protect_avatar"
    }
  }, [_vm._v(" 群組頭點保護 ")]), _c('b-form-checkbox', {
    staticClass: "ml-2 mb-2",
    model: {
      value: _vm.currentGroup.protect_name,
      callback: function callback($$v) {
        _vm.$set(_vm.currentGroup, "protect_name", $$v);
      },
      expression: "currentGroup.protect_name"
    }
  }, [_vm._v(" 群組名稱保護 ")]), _c('b-form-checkbox', {
    staticClass: "ml-2 mb-2",
    model: {
      value: _vm.currentGroup.protect_album,
      callback: function callback($$v) {
        _vm.$set(_vm.currentGroup, "protect_album", $$v);
      },
      expression: "currentGroup.protect_album"
    }
  }, [_vm._v(" 相簿保護 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    }
  }, [_vm._v("返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.guardGroup
    },
    on: {
      "click": _vm.setProtectOfGroup
    }
  }, [_vm._v("儲存")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }